module.exports = __webpack_public_path__ + "static/media/fave-feed-post-submitted-scheduled.15a284c7.svg";